<template>
  <div class="popup-full  _new-design  modal-call-back">
    <div class="popup-full__wrap">

      <button type="button"
              @click.prevent="onClose"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__main">
            <BasePreloader v-if="pendingMain"/>
            <template v-if="receivedData">
              <div class="popup-full__media">
                <picture class="popup-full__img">
                  <source :srcset="receivedData.image_webp" type="image/webp"/>
                  <img :src="receivedData.image"
                       :alt="$tModalsAuto('Do you want, we call you?')">
                </picture>
              </div>

              <h3 style="font-size: 2.5rem"
                  class="popup-full__title">{{ receivedData.heading }}</h3>
              <div style="font-size: 1.8rem;font-weight: 500"
                   class="popup-full__text text">
                <p>{{
                    receivedData.description
                  }}</p>
              </div>

              <BaseInputPhone v-model="inputs.phone.value"
                              :error="inputs.phone.error"
                              type="tel"
                              :placeholder="$tModalsAuto('Your phone')"
                              @validate="onValidatePhone"
                              class="modal-call-back__input"/>

              <BaseAlert :value="overallErrorsMix"
                         :class="invalidPhone ? '_error' : '_warning'"
                         class="modal-call-back__error"/>

              <button v-if="isValidPhone"
                      @click.prevent="onSend"
                      class="modal-call-back__btn  base-btn  base-btn--blue">
                {{ $tModalsAuto('Call me') }}
                <BasePreloader v-if="pending"
                               class="_small"/>
              </button>
              <button v-else
                      disabled
                      class="modal-call-back__btn  base-btn  base-btn--blue">
                {{ $tModalsAuto('Call me') }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import formMixins from '@/mixins/formMixins'

  export default {
    name: 'ModalCallBack',
    mixins: [formMixins],
    props: {
      location: String
    },
    data() {
      return {
        pending: false,
        pendingMain: false,
        receivedData: null,
        inputs: {
          phone: {
            value: null,
            phoneObject: null
          }
        },
        invalidPhone: false,
      }
    },
    computed: {
      phone() {
        return this.$get(this.$store.state.user, 'profile.phone', null)
      },
      isValidPhone() {
        return this.$get(this.inputs.phone, 'phoneObject.valid')
      }
    },
    methods: {
      loadData() {
        this.pendingMain = true

        return http.get('/api/helper/popups')
          .then(({data}) => {
            this.receivedData = data.data.find(d => {
              return d.type === 'phone' && d.location === this.location
            })
          })
          .finally(() => {
            this.pendingMain = false
          })
      },
      onClose() {
        this.$vModal.close('call-back')
      },
      onSend() {
        this.pending = true
        this.invalidPhone = false;
        this.resetErrorsMix(this.inputs)

        http.post('/api/callback/form', {
          phone: this.inputs.phone.value,
          form_from: this.getRouteNameMixin(),
          full_path: this.$route.fullPath,
          vacancy_slug: this.$route.params.vacancyId
        })
          .then(() => {
            this.onClose()
            this.$vModal.open('successfully-sent', {
              title: this.$tModalsAuto('call-back-sent-title'),
              text: `<p>${this.$tModalsAuto('call-back-sent-text')}</p>`
            })
          })
          .catch(e => {
            if (e.response.data.code === 60) {
              this.invalidPhone = true;
            }
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      },
      onValidatePhone(phoneObject) {
        this.inputs.phone.phoneObject = phoneObject
      }
    },
    created() {
      this.inputs.phone.value = this.phone

      this.loadData()
    },
    watch: {
      phone(v) {
        this.inputs.phone.value = v
      }
    }
  }
</script>

<style lang="less">

</style>
